import { SUPPORT_LANGUAGES } from '@/root';

function resolveLanguageFromPathname(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const { pathname } = window.location;
  const matched = SUPPORT_LANGUAGES.find(
    item => pathname === `/${item.path}` || pathname.startsWith(`/${item.path}/`),
  );
  return matched?.value;
}

/** 从路由 prop 或 URL 前缀解析语言；无前缀时返回 undefined，不覆盖已保存语言 */
export function resolvePathLanguage(lang?: string): string | undefined {
  return lang ?? resolveLanguageFromPathname();
}

export function pathnameHasLanguagePrefix(): boolean {
  if (typeof window === 'undefined') return false;
  const { pathname } = window.location;
  return SUPPORT_LANGUAGES.some(
    item => pathname === `/${item.path}` || pathname.startsWith(`/${item.path}/`),
  );
}
